/* eslint-disable react-hooks-ssr/react-hooks-global-ssr */
import { Logger } from 'AppShell/appshell_types/loggerTypes';
import { AbstractAppBridge, NotificationType, WindowType } from 'AppShell/appshell_types/appBridgeTypes';

declare const window: WindowType;

export default class AppBridge implements AbstractAppBridge {
    public static instance: AppBridge;

    private readonly logger: Logger;

    private constructor(logger: Logger) {
        this.logger = logger;
    }

    public static getInstance(logger: Logger): AppBridge {
        if (!this.instance) {
            this.instance = new this(logger);
        }

        return this.instance;
    }

    public sendTrackingData(data: any): void {
        let message = data;
        if (window.AndroidAppBridge) {
            const isKnownEvent = !!data?.event;

            message = isKnownEvent
                ? {
                      ...data,
                      event_category: data.category,
                      event_action: data.action,
                      event_label: data.label,
                  }
                : data;
        }

        this.postMessage('updateDataLayer', message);
    }

    public sendShowCheckoutEvent(url: string): void {
        this.postMessage('showCheckout', url);
    }

    public sendShowCDPEvent(url: string): void {
        this.postMessage('showCDP', url);
    }

    public sendShowOverlay(url: string): void {
        this.postMessage('showOverlay', url);
    }

    public sendShowProductEvent(sku: string): void {
        this.postMessage('showProduct', sku);
    }

    public sendShowLoginEvent(data: any): void {
        this.postMessage('showLogin', data);
    }

    public sendNotification(data: NotificationType): void {
        const { type, message } = data;
        this.postMessage('displayMessage', { type, text: message });
    }

    public postMessage(action: string, message: any): void {
        try {
            if (window?.AndroidAppBridge?.postMessage) {
                const payload = JSON.stringify({
                    action,
                    message,
                });

                window.AndroidAppBridge.postMessage(payload);
            } else if (window?.webkit?.messageHandlers?.appBridge?.postMessage) {
                window.webkit.messageHandlers.appBridge.postMessage({ action, message });
            } else {
                this.logger.warn('No tracker is found for webview. User might have accidentally turned on webview', {
                    androidAppBridgePresent: !!window?.AndroidAppBridge,
                    androidAppBridgePostPresent: !!window?.AndroidAppBridge?.postMessage,
                    iosAppBridgePresent: !!window?.webkit?.messageHandlers?.appBridge,
                    iosAppBridgePostPresent: !!window?.webkit?.messageHandlers?.appBridge?.postMessage,
                });
            }
        } catch (e) {
            this.logger.error(`AppBridge - event triggering error. Message: ${e.message}`, {
                action,
                message,
            });
        }
    }
}

export const windowObjectIndicatesWebView = () =>
    !!window?.AndroidAppBridge || !!window?.webkit?.messageHandlers?.appBridge;
